import React, { Component } from 'react'
import fbConfig from '../../../../../config/firebaseConfig'
import { connect } from 'react-redux'
import NotificationItem from '../Notifications/NotificationItem'
//Design
import { Paper } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';


 class Notifications extends Component {

  constructor(props){
    super(props);
    this.state = {
      name: '',
      companyId: '',
      role: '',
      notifications:[]
    }
  }
  generateRandomColor() {
    let r = Math.round((Math.random() * 255)); //red 0 to 255
    let g = Math.round((Math.random() * 255)); //green 0 to 255
    let b = Math.round((Math.random() * 255)); //blue 0 to 255
    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  };
  getNotifications = () => {
    console.log(this.state)
    if(this.props.profile.companyId){
      console.log(this.props.profile.companyId)
      let {companyId, role, id}= this.props.profile
      console.log(companyId, role, id)
      const db = fbConfig.firestore();
       
      db.collection(this.props.profile.companyId).doc('companyUsers').collection(role+'s').doc(id).collection('notifications')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
         // console.log(doc.id)
          let data = doc.data();
         // console.log(data)
          this.setState({
            ...this.state,
            notifications: [...this.state.notifications, data],
          });
          
        });
      });
    }
  }
  initialize = async () => {

    if(this.props.profile.companyId){
      
      await this.getNotifications()
    }
    
  }
  componentWillReceiveProps = () => {
    this.setState({
        name: this.props.profile.name,
        companyId: this.props.profile.companyId,
        role: this.props.profile.role, 
    })
    if(Object.keys(this.state.notifications).length === 0){
         this.initialize()
    }
    
  }
  componentDidMount =() => {
    
  }
  render() {
    
   // console.log('Notificacions  PROPS', this.props)
    //console.log('Notificacions STATE ', this.state)
    let notificationsList = this.state.notifications.map( notification => {
      return  <NotificationItem data={notification} color={this.generateRandomColor()}/>
    })
    return (
      <div className="slideUp">

          <Typography component="h1" variant="h5">
          Notifications
          </Typography>
          <Paper style={{padding: '24px', marginTop: '24px' }}>
              <List>
                { this.state && this.state.notifications.length === 0 ? 
                  <Typography  component="h1" variant="h5">
                     There is no messages
                  </Typography>
                :
                notificationsList}
              
              </List>
         </Paper>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  }
}
export default connect(mapStateToProps, null)(Notifications)
